export enum ExternalBeltPosition {
  CENTER= 'center',
  LEFT = 'left',
  RIGHT = 'right',
  NOTCONNECTED = ''
}
